import TrackString from "../../../analytics/TrackString";
import HubEvent from "../../../app/hub/event/HubEvent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import GameEvent from "../../../core/application/GameEvent";
import NavigateEvent from "../../../core/navigation/NavigateEvent";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";
import NGTDialogFactory from "../NGTDialogFactory";
import NGTDialogPlayer from "../NGTDialogPlayer";
import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";
import DialogPlayerRegisterEvent from "./DialogPlayerRegisterEvent";
/**
 * PlayDialogCommand.js
 * 
 * Created on Oct 8, 2013, 3:36:48 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class PlayDialogCommand extends AbstractCommand {
    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTDialogFactory} dialogFactory 
     * @param {NGTDialogPlayer} dialogPlayer 
     */
    constructor(dispatcher, dialogFactory, dialogPlayer) {
        super(dispatcher);
        this._dialogFactory = dialogFactory;
        this._dialogPlayer = dialogPlayer;

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
        this._handleAbortDialogBound = this._handleAbortDialog.bind(this);
    }

    execute(event) {
        this.dispatch(GameEvent.PAUSE_GAME);
        this.dispatch(HubEvent.HIDE_HUB);

        const content = event.params.data.content;
        this._dialogPlayer.setContentPlayer(event.params.data.contentPlayer);
        this._dialogPlayer.setContent(content);

        const dialogId = content.getDialogID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog start
        this.trackEvent(TrackString.EVENT_DIALOG_START, TrackString.createDialogParams(dialogId));

        this._dialogPlayerSkin = SkinFactory.getSkin(SkinKeyRegistry.DIALOG_SCREEN_SKIN);
        this._dialogPlayerSkin["dialogPanel"].dialogPlayer = this._dialogPlayer;
        this._dialogPlayerSkin["dialogPlayer"] = this._dialogPlayer;
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._handleContentCompletedBound, this);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_ABORT, this._handleAbortDialogBound, this);

        const commandEvent = new NavigateEvent(NavigateEvent.OPEN_SCREEN_REQUEST, this._dialogPlayerSkin.skinType, this._dialogPlayerSkin);
        this.dispatch(commandEvent.type, { data: commandEvent });

        this._startTime = Date.now();
        this._dialogPlayer.viewContent();
    }

    _handleContentCompleted({ params }) {
        this.dispatch(GameEvent.RESUME_GAME);
        this.dispatch(HubEvent.SHOW_HUB);

        if (params.contentPlayer !== this._dialogPlayer) {
            return;
        }

        const dialogId = this._dialogPlayer.getContent()?.getDialogID();
        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog end
        this.trackEvent(TrackString.EVENT_DIALOG_END, TrackString.createDialogParams(dialogId));

        this._closeContent();
        this.destroy();
    }

    _handleAbortDialog({ params }) {
        if (params.contentPlayer !== this._dialogPlayer) {
            return;
        }

        this._closeContent();
        this.destroy();
    }

    _closeContent() {
        const commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._dialogPlayerSkin);
        this.dispatch(commandEvent.type, { data: commandEvent });
    }

    destroy() {
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._handleContentCompletedBound);
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_ABORT, this._handleAbortDialogBound, this);
        this._dialogPlayer.destroy();
        this._dialogPlayer = null;
        this._dialogPlayerSkin = null;
    }
}